var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
export class RuntimeSync {
    parent;
    isJustSimulating = false;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    syncronizedEntities = observable.map();
    entityFetchDeduplication = new Map();
    addEntityToSyncronizedEntities(model, entity) {
        const storeKey = `${model.id}_${model.owner.type}_${model.owner.id}_${entity.type}_${entity.id}`;
        this.syncronizedEntities.set(storeKey, entity);
    }
    writeRequests = new Map();
    get unObservedKeys() {
        return Array.from(this.syncronizedEntities._hasMap.entries())
            .filter(e => !e[1].isBeingObserved)
            .map(e => e[0]);
    }
}
__decorate([
    observable.shallow
], RuntimeSync.prototype, "syncronizedEntities", void 0);
__decorate([
    observable.shallow
], RuntimeSync.prototype, "writeRequests", void 0);
